// extracted by mini-css-extract-plugin
export default {"cell":"yxF8CyzmmTLEMe4dzQQ0","name":"GsgO1YNKIodcWrTOq8Xr"};